module.exports = __webpack_public_path__ + "img/eclipse-rectangle-high-angle.b0cd5ba7.png";